import React from 'react';
import ToolbarMenuItem from 'features/toolbar/ToolbarMenuItem/ToolbarMenuItem';
import { MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';
import { EMOJI_ICONS, EMOJIS_LIST } from 'features/room-reactions/constants';
import { useRoomReactionsControl } from 'features/toolbar/toolbar/controls/room-reactions/useRoomReactionsControl';

const StyledEmojiButton = styled(MenuItem)(({ theme }) => ({
  padding: theme.spacing(1),
  minWidth: '44px',
  height: '44px',
  justifyContent: 'center',
  borderRadius: theme.shape.borderRadius,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

const EmojiIcon = styled('img')({
  width: '32px',
  height: '32px',
  display: 'block',
});

const RoomReactionsControl = () => {
  const { isFeatureAvailable, label, sendReaction, icon } = useRoomReactionsControl();

  if (!isFeatureAvailable) {
    return null;
  }

  return (
    <ToolbarMenuItem
      id="reactions-control"
      icon={icon}
      overlay={label}
      menu
      MenuProps={{
        PopperProps: {
          sx: (theme) => ({ zIndex: theme.zIndex.popper }),
        },
        sx: {
          display: 'flex',
          flexDirection: 'row',
          padding: 0.5,
        },
        closeOnItemClick: false,
      }}
    >
      {EMOJIS_LIST.map((reaction) => (
        <StyledEmojiButton key={reaction} onClick={() => sendReaction(reaction)}>
          <EmojiIcon src={EMOJI_ICONS[reaction]} alt={reaction} />
        </StyledEmojiButton>
      ))}
    </ToolbarMenuItem>
  );
};

export default RoomReactionsControl;
